import { gql } from '@apollo/client';

const Fragments = {
  financialProductItem: gql`
    fragment financialProductItem on FinancialProductItem {
      productId
      productName
      productCode
      description
      isActive
      hasSeasonalityTemplates
    }
  `,
  leasingFinancialProductItem: gql`
    fragment leasingFinancialProductItem on LeasingFinancialProductItem {
      productId
      validFrom
      validTo
      isSpecialAction
      leasingTypeId
      promoId
      creditCurrencyId
      scheduleTypeId
      leasingIncomeSchemaId
      interestTypeId
      paymentFrequency
      contractDuration
      filterCondition
    }
  `,
  financialProductXBusinessFlow: gql`
    fragment financialProductXBusinessFlow on FinancialProductXBusinessFlowItem {
      productId
      flowId
      currentStateId
      currentStateName
    }
  `,
  financialProductFilters: gql`
    fragment financialProductFilters on FinancialProductFilters {
      filterId
      orderNo
      paramId
      paramName
      operatorId
      operatorName
      operatorIsMultipleSelection
      filterValueId
      filterValue
      filterValues {
        financialProductFilterValueId
        filterId
        filterValueId
        filterValue
      }
    }
  `,
  financialProductRule: gql`
    fragment financialProductRule on FinancialProductRuleEditItem {
      financialProductRuleId
      productId
      ruleCode
      ruleDescription
      generalYN
      filterCondition
      ruleFilters {
        filterId
        financialProductRuleId
        orderNo
        paramId
        paramName
        paramIsList
        operatorId
        operatorName
        operatorIsMultipleSelection
        filterValue
        filterValueId
        filterValues {
          financialProductRuleConditionValueId
          filterId
          filterValue
          filterValueId
        }
      }
      outputData {
        financialProductRuleOutputDataId
        financialProductRuleId
        readOnlyYN
        paramId
        paramName
        defaultValue
        minValue
        maxValue
      }
      outputDictionaries {
        financialProductRuleOutputDictionaryId
        financialProductRuleId
        readOnlyYN
        paramId
        paramName
        filterValue
        filterValueId
      }
    }
  `,
  financialProductWarranty: gql`
    fragment financialProductWarranty on FinancialProductWarrantyItem {
      leasingFinancialProductXWarrantyId
      productId
      quantity
      warrantyTypeName
      quantityTypeName
      mandatory
    }
  `,
  financialProductProperty: gql`
    fragment financialProductProperty on FinancialProductPropertyItem {
      leasingFinancialProductPropertyId
      propertyId
      productId
      propertyName
      propertyValue
      mandatory
    }
  `,
  financialProductResidualValueGrid: gql`
    fragment financialProductResidualValueGrid on FinancialProductResidualValueGridItem {
      financialProductXResidualValueGridId
      productId
      gridId
      gridName
      maximumIncrease
      maximumDecrease
    }
  `,
  financialProductInsurer: gql`
    fragment financialProductInsurer on FinancialProductInsurerItem {
      leasingFinancialProductXLeasInsurerId
      productId
      insTypeId
      insuranceTypeName
      insurerId
      insurerName
      insuranceConventionId
      insuranceConventionName
      implicit
      mandatory
    }
  `,
  financialSeasonalityTemplate: gql`
    fragment financialSeasonalityTemplate on FinancialProductSeasonalityTemplateItem {
      seasonalityTemplateId
      productId
      templateId
      default
    }
  `
};
export default Fragments;
